import React, { useState, useEffect }  from 'react'
import { Table,  Space } from 'antd'
import Main from '../../../cpn/Main';
import LoanNodeDel from './LoanNodeDel';            
import LoanNodeAdd from './LoanNodeAdd';
import LoanNodeCheck from './LoanNodeCheck';
import LoanNodeCopyAdd from './LoanNodeCopyAdd';
import { useJKspjdListQuery } from '../../../store/DianShangYeWuApi';
function LoanNodeList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useJKspjdListQuery({jk_spjd_qy_id:qy_id});
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){            
            // 找出所有不同的jk_spjd_user_id并合并
            const mergedArr = [];
            const userMap = {};
            data.Result.forEach(item => {
                // 用jk_spjd_user_id去合并
                if (item.jk_spjd_user_id && !userMap[item.jk_spjd_user_id]) {
                    userMap[item.jk_spjd_user_id] = {
                        key: item.jk_spjd_user_id,
                        jk_spjd_user_id: item.jk_spjd_user_id,
                        jk_spjd_user_name: item.jk_spjd_user_name,
                        jk_spjd_name: item.jk_spjd_name,
                        jk_spjd_yh_id: item.jk_spjd_yh_id,
                        jk_spjd_yh_name: item.jk_spjd_yh_name,
                        yh_id: item.jk_spjd_yh_id,
                        yh_name: item.jk_spjd_yh_name,
                    }
                    mergedArr.push(userMap[item.jk_spjd_user_id])
                }
            })
            setList(mergedArr);
        }else{
            setList([]);
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '借款单操作员',
            dataIndex: 'jk_spjd_user_name',
            key: 'jk_spjd_user_name',
            width: 300, 
            render: (text, record) => <Space>
                <LoanNodeCheck
                    user_id={record.jk_spjd_user_id}
                    user_name={record.jk_spjd_user_name}
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    jk_spjd_user_id={record.jk_spjd_user_id}
                    jk_spjd_user_name={record.jk_spjd_user_name}
                />
            </Space>
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => <Space size={20}>
                <LoanNodeDel
                    jk_spjd_user_id={record.jk_spjd_user_id}                    
                />
                <LoanNodeCopyAdd
                    jk_spjd_user_id={record.jk_spjd_user_id}  
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Space>
        },
    ]
    return (
        <Main selectedKeys={['/LoanNodeList']}>
            <LoanNodeAdd  
                qy_id={qy_id}
                qy_name={qy_name}
                yh_id={yh_id}
                yh_name={yh_name}
            />
            <Table
                columns={columns}
                dataSource={list}
                style={{marginTop:'10px',width:'500px'}}
                className="custom-table"
                size='small'
                bordered
                rowKey="key"
            />
        </Main>
    )
}

export default LoanNodeList